import { createContext } from 'react';

/**
 * React context that holds a function to transform a URL string.
 * @type {React.Context<(url: string) => string>}
 */
const UrlContext = createContext((url) => url);

export const UrlProvider = UrlContext.Provider;
export const UrlConsumer = UrlContext.Consumer;

export default UrlContext;
